import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, onUnmounted, ref, Ref} from 'vue';
import vuetify from "@/plugins/vuetify";
import {useStore} from "@/store";
import AproconHeader from '@aprocon-software/aprocon-header';
import moment from 'moment-mini';
import ClientAbout from '@/components/about/ClientAbout.vue';
import ServiceAbout from '@/components/about/ServiceAbout.vue';
import router from "@/router";
import Services from "@/assets/js/services/Services";

export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

let currentRouter: any | undefined;
const store = useStore();
let loading: boolean = false;
let branchName: Ref<string> = ref("");
let mCurrentTime: string = '';
let clockTimer!: any;
let tab=ref(null);
const isLoggedIn:Ref<boolean> = ref(false);
async function logout(): Promise<void> {
    isLoggedIn.value = false;
    await store.dispatch('logout');
}
function created(){
    currentRouter = router;
    if(store.getters.isLoggedIn()) {
        onMounted(() => mounted());
        onUnmounted(() => unmounted());
    }
}
const currentTime = computed<string>(() => {
    return mCurrentTime;
});
const currentDate = computed<string>(() => {
    return moment(new Date()).format('dddd , DD.MM.YYYY');
});

function mounted(): void {
    const authToken = store.getters.authToken();
    isLoggedIn.value =  authToken !== null && authToken !== '';
    Services.Apps.getBranches(store.getters.userId()).then((items) => {
        items.find(item => {
            if (item.Nummer == store.getters.branchId()) {
                branchName.value = item.Name;
                return true;
            }
            return false;
        });
    });
    setCurrentTime();
}

function unmounted(): void {
    if (clockTimer) {
        window.clearTimeout(clockTimer);
    }
}

function setCurrentTime(): void {
    const date = new Date();
    mCurrentTime = moment(date).format('HH:mm');
    if (clockTimer) {
        window.clearTimeout(clockTimer);
    }
    clockTimer = window.setTimeout(setCurrentTime, (60 - date.getSeconds()) * 1000);
}

created();

return { __sfc: true,currentRouter, store, loading, branchName, mCurrentTime, clockTimer, tab, isLoggedIn, logout, created, currentTime, currentDate, mounted, unmounted, setCurrentTime, vuetify, AproconHeader, ClientAbout, ServiceAbout }
}

})